<template>
  <div>
    <el-card class="background" element-loading-background="rgba(255, 255, 255, 0.7)">
      <div class="repair-bill">
        <el-collapse v-model="activeCollapses" class="collapse-main-content">
          <!-- 报修信息 -->
          <el-collapse-item name="1">
            <template slot="title">
              <div class="collapse-title-pre">
                <span></span>
                报修信息
              </div>
            </template>
            <div class="collapse-content">
              <SiruiSearch
                @changeMethod="changeMethod"
                ref="baseInfoFormRef"
                :query="repairInfoFormData"
                :columns="initColumn"
                :rules="baseRules"
                :isQueryPanel="false"
              >
              </SiruiSearch>
            </div>
          </el-collapse-item>

          <!-- 维修项目 -->
          <el-collapse-item name="2">
            <template slot="title">
              <div class="collapse-title-pre">
                <span></span>
                维修项目
              </div>
            </template>
            <div class="collapse-content" v-if="pageMode == 1 || pageMode == 2">
              <vxe-grid
                border
                show-overflow
                resizable
                ref="maintenanceTableRef"
                class="vxe-table-element"
                size="mini"
                align="center"
                :auto-resize="true"
                :edit-rules="baseRules"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :data="maintenanceTableData"
                :toolbar="{}"
                :valid-config="{ autoPos: true, message: 'inline' }"
                @select-change="handleSelectionChange"
                @select-all="handleSelectionChange"
                @edit-closed="closeEditTableHandler"
                height="300"
              >
                <template v-slot:buttons>
                  <el-button
                    @click="$refs.maintenanceTableRef.commitProxy('insert_actived')"
                    size="small"
                    type="primary"
                    class="vxe-btn-primary"
                    >新增</el-button
                  >
                  <el-button
                    @click="deleteBtnClickHandler"
                    size="small"
                    type="danger"
                    class="vxe-btn-delete"
                    >删除</el-button
                  >
                </template>
                <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
                <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
                <vxe-table-column
                  v-for="(item, index) in addMaintenanceTableColumns"
                  :key="index"
                  :type="item.type"
                  :field="item.field"
                  :title="item.title"
                  :width="item.width"
                  :edit-render="item.editRender"
                >
                  <template v-slot="{ row }">
                    <span v-if="item.field == 'type'">
                      {{ getName('type', row[item.field]) }}
                    </span>
                    <span v-else>
                      {{ row[item.field] }}
                    </span>
                  </template>
                  <template v-slot:edit="{ row }">
                    <el-input
                      v-if="item.editRender.name == 'input'"
                      v-model="row[item.field]"
                      :disabled="disable"
                    ></el-input>
                    <el-input
                      v-if="item.editRender.name == 'textarea'"
                      v-model="row[item.field]"
                      type="textarea"
                      :disabled="disable"
                    ></el-input>
                    <el-input
                      v-if="item.editRender.name == 'planInput'"
                      v-model="row[item.field]"
                      :disabled="disable"
                      type="textarea"
                      maxlength="500"
                    ></el-input>
                    <!--数字输入框--显示2位-->
                    <inputNumberAd
                      v-model="row['estimatedCost']"
                      v-if="item.editRender.name == 'ElInput'"
                      :controls="false"
                      :precision="2"
                      :min="0"
                      :max="99999999999999999"
                      @input="(e) => handleChange(row, item.field)"
                    ></inputNumberAd>
                    <el-select
                      v-else-if="item.editRender.name == 'select'"
                      :disabled="disable"
                      clearable
                      v-model="row[item.field]"
                    >
                      <el-option
                        v-for="(i, index) in item.editRender.options"
                        :key="index"
                        :label="i.label"
                        :value="i.value"
                      ></el-option>
                    </el-select>
                    <el-input
                      v-else-if="item.editRender.name == 'cost'"
                      v-model="row[item.field]"
                      :disabled="disable"
                    ></el-input>
                  </template>
                </vxe-table-column>
              </vxe-grid>
            </div>
            <div class="collapse-content" v-if="pageMode == 4 || pageMode == 3">
              <vxe-grid
                border
                show-overflow
                resizable
                ref="maintenanceTableRef"
                class="vxe-table-element"
                size="mini"
                align="center"
                :auto-resize="true"
                :edit-rules="baseRules"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :data="maintenanceTableData"
                :toolbar="{}"
                :valid-config="{ autoPos: true, message: 'inline' }"
                @select-change="handleSelectionChange"
                @select-all="handleSelectionChange"
                @edit-closed="closeEditTableHandler"
                height="300"
              >
                <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
                <vxe-table-column
                  v-for="(item, index) in detailMaintenanceTableColumns"
                  :key="index"
                  :type="item.type"
                  :field="item.field"
                  :title="item.title"
                  :width="item.width"
                  :edit-render="item.editRender"
                >
                  <template v-slot="{ row }">
                    <span v-if="item.field == 'type'">
                      {{ getName('type', row[item.field]) }}
                    </span>
                    <span v-else>
                      {{ row[item.field] }}
                    </span>
                  </template>
                  <template v-slot:edit="{ row }">
                    <el-input
                      v-if="item.editRender.name == 'input'"
                      v-model="row[item.field]"
                      :disabled="disable"
                    ></el-input>
                    <el-input
                      v-if="item.editRender.name == 'textarea'"
                      v-model="row[item.field]"
                      :disabled="disable"
                      type="textarea"
                    ></el-input>
                    <!-- <el-input
                      v-if="item.editRender.name == 'planInput'"
                      v-model="row[item.field]"
                      :disabled="disable"
                      maxlength="50"
                    ></el-input> -->
                    <!--数字输入框--显示2位-->
                    <inputNumberAd
                      v-model="row['estimatedCost']"
                      v-if="item.editRender.name == 'ElInput'"
                      :controls="false"
                      :precision="2"
                      :min="0"
                      :max="99999999999999999"
                      @input="(e) => handleChange(row, item.field)"
                      :disabled="pageMode == 4"
                    ></inputNumberAd>
                    <el-select
                      v-else-if="item.editRender.name == 'select'"
                      :disabled="disable"
                      clearable
                      v-model="row[item.field]"
                    >
                      <el-option
                        v-for="(i, index) in item.editRender.options"
                        :key="index"
                        :label="i.label"
                        :value="i.value"
                      ></el-option>
                    </el-select>
                    <el-input
                      v-else-if="item.editRender.name == 'planInput'"
                      v-model="row[item.field]"
                      :disabled="pageMode == 4"
                      type="textarea"
                      maxlength="500"
                    ></el-input>
                  </template>
                </vxe-table-column>
              </vxe-grid>
            </div>
          </el-collapse-item>

          <!-- 附件 -->
          <el-collapse-item name="3">
            <template slot="title">
              <div class="collapse-title-pre">
                <span></span>
                附件
              </div>
            </template>
            <div class="collapse-content">
              <FileTable
                ref="fileTableRef"
                :fileType="fileType"
                :limitFileCount="10"
                :attachments="attachments"
                :isShowDownBtn="isShowDownBtn"
              />
            </div>
          </el-collapse-item>

          <!-- 审批信息----审核 -->
          <el-collapse-item name="4" v-if="pageMode == 3">
            <template slot="title">
              <div class="collapse-title-pre">
                <span></span>
                审批信息
              </div>
            </template>
            <div class="collapse-content">
              <SiruiSearch
                ref="auditInfoFormRef"
                :query="auditFormData"
                :columns="approvalInfoColumns"
                :rules="baseRules"
                :isQueryPanel="false"
              >
              </SiruiSearch>
            </div>
          </el-collapse-item>

          <!-- 维修费用类型 -->
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="120px"
            disabled
            v-if="pageMode == 4"
          >
            <el-form-item label="维修费用类型" prop="repairPriceType">
              <el-select v-model="form.repairPriceType">
                <el-option
                  v-for="(item, index) in repairExpenseTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <!-- 审核记录----详情信息 -->
          <!-- <el-collapse-item name="5" v-if="pageMode == 4">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              审核记录
            </div>
          </template>
          <div class="collapse-content">
            <sirui-table
              ref="auditRecordSiruiTable"
              :loading="load"
              :data="auditRecordTableData"
              :paging="true"
              :setting="false"
              :customVisible="false"
              :columns="auditColumns"
            >
              <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
              <vxe-table-column
                align="center"
                v-for="(item, index) in auditColumns"
                :key="index"
                :field="item.field"
                :title="item.title ? $t(item.title) : null"
                :visible="item.visible"
                :type="item.type"
              >
                <template v-slot="{ row }">
                  <template>{{ row[item.field] }}</template>
                </template>
              </vxe-table-column>
            </sirui-table>
          </div>
        </el-collapse-item> -->

          <!-- 底部按钮(新增，编辑) -->
          <div class="text-center" v-if="pageMode == 1 || pageMode == 2">
            <el-button type="primary" @click="saveBtn" class="save">保存</el-button>
            <el-button type="primary" @click="submitBtn" class="submit">提交审核</el-button>
            <el-button @click="cancelBtnClickHandler">取消</el-button>
          </div>

          <!-- 底部按钮 (审核) -->
          <div class="text-center" v-if="pageMode == 3">
            <el-button type="primary" @click="passBtn" class="save">通过</el-button>
            <el-button type="primary" @click="rejectBtn" class="submit">驳回</el-button>
            <el-button @click="cancelBtnClickHandler">取消</el-button>
          </div>
          <div class="text-center" v-if="pageMode == 4">
            <el-button
              v-if="repairInfoFormData.auditStatus == '审核中'"
              type="primary"
              @click="recall"
              class="save"
              >撤回申请</el-button
            >
          </div>
        </el-collapse>
      </div>
    </el-card>
    <RepairTypeDialog
      ref="repairTypeDialogRef"
      @getRepairPriceType="getRepairPriceType"
    ></RepairTypeDialog>
  </div>
</template>

<script>
  import {
    detailsFormColumn,
    auditFormColumn,
    addEditFormColumn,
    maintenanceColumn,
    maintenanceColumn1,
    auditColumn,
  } from './columns/tableColumns.js';
  import { columnRules } from './columns/rules.js';
  import { formatDate } from '@/utils/date';
  import SiruiSearch from '@/components/SiruiSearch';
  // import BASE_API from '@/api/dataBase.js';
  import API from '@/api/property/repairMagement.js';
  import mixin from './mixin.js';
  import RepairTypeDialog from './component/repairTypeDialog';

  export default {
    name: 'addRepairBill',
    mixins: [mixin],
    data() {
      return {
        pageMode: 0,
        multipleSelection: [],
        fileTableSelection: [], // 附件表格选择列表
        isShowDownBtn: false,
        auditColumns: [],
        addMaintenanceTableColumns: [],
        detailMaintenanceTableColumns: [],
        baseRules: columnRules,
        maintenanceTableData: [],
        disable: false, // 禁用输入框
        repairInfoFormData: {
          repairPersonName: '',
          repairDate: '',
          repairDepartmentName: '',
        },
        auditRecordTableData: [], // 审核记录表格数据
        auditFormData: {},
        load: false,
        tableData: [], // 维修项目表格
        fileTableData: [],
        activeCollapses: ['1', '2', '3', '4', '5'],
        approvalInfoColumns: [
          {
            name: '审核信息',
            prop: 'message',
            type: 'textarea',
            span: 24,
            maxlength: 50,
          },
        ],
        fileType: ['xls', 'xlsx', 'txt', 'doc', 'docx', 'pdf', 'jpg', 'png'],
        repairId: '',
        repairProjects: [], // 维修信息
        submitFlag: false, //保存、提交审核标志
        reviewFlag: true, // 通过、驳回标志
        attachments: [],
        typeList: [
          {
            label: '水电',
            value: '01',
          },
          {
            label: '设备',
            value: '02',
          },
          {
            label: '电器',
            value: '03',
          },
          {
            label: '其他',
            value: '04',
          },
        ],
        form: {
          repairPriceType: '',
        }, //维修费用类型
        repairExpenseTypeList: [],
      };
    },
    computed: {
      rules() {
        return {
          repairPriceType: [{ required: true, message: '维修费用类型必填' }],
        };
      },
      initColumn() {
        if (this.pageMode == 1 || this.pageMode == 2) {
          return addEditFormColumn(this);
        } else if (this.pageMode == 3) {
          return auditFormColumn(this);
        } else {
          return detailsFormColumn(this);
        }
      },
    },
    mounted() {
      console.log('代办跳转审核单', this.$route.query);
      this.repairExpenseTypeList = this.dictListMap?.repairExpenseType;
      this.auditColumns = auditColumn(this);
      this.addMaintenanceTableColumns = maintenanceColumn(this);
      this.detailMaintenanceTableColumns = maintenanceColumn1(this);
      if (this.$route.query?.pageMode) {
        this.pageMode = Number(this.$route.query?.pageMode);
      }
      if (this.pageMode == 1) {
        this.setAddDefault();
      }
      if (this.pageMode == 3 || this.pageMode == 4) {
        console.log('mounted', this.$route.query);
        this.isShowDownBtn = this.pageMode == 3 ? false : true;
        this.disable = true;
      }
      if (this.pageMode == 4 || this.pageMode == 2 || this.pageMode == 3) {
        this.repairId = this.$route.query?.repairId;
        this.getFormData();
      }
      // this.getTodoList()
      this.getDepartment();
      this.getCompany();
      this.repairInfoFormData.repairCompanyNo = this.userInfo.companyCode;
    },
    methods: {
      //通过时获取维修费用类型
      getRepairPriceType(val) {
        console.log('val', val);
        this.repairPriceType = val;
        this.passBtnClickHandler(this.reviewFlag);
      },
      // 数字输入框
      handleChange(row, field) {
        console.log('数字', row, field);
      },
      // 新增页面获取默认值
      setAddDefault() {
        this.repairInfoFormData.repairPersonName = this.userInfo.personName;
        this.repairInfoFormData.repairDate = formatDate(new Date());
      },
      // 更新列
      updateCol(val, row, field) {
        console.log(field, '当前字段');
        row['estimatedCost'] = val;
      },
      recall() {
        this.loading = true;
        this.$axios
          .post('/property/repair/withdrawApproval', {
            idList: [this.repairInfoFormData.id],
          })
          .then((res) => {
            console.log(res);
            this.loading = false;
            const { code, msg } = res.data;
            if (code == 0) {
              this.$message.success('撤回成功');
              let pathList = {
                fromPath: {
                  path: this.$route.path,
                  name: this.$route.name,
                  meta: {
                    keepAlive: true,
                    // title: '添加报修单',
                  },
                },
                toPath: {
                  path: '/property/repairsManagement',
                  name: 'repairsManagement',
                  meta: {
                    keepAlive: false,
                  },
                },
              };
              this.$store.dispatch('tagsView/delView', pathList.fromPath).then(() => {
                this.$nextTick(() => {
                  this.$router.push(pathList.toPath);
                });
              });
            } else {
              this.$message.error(msg);
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
      // 获取页面提交的数据
      async getSubmitData() {
        let params = null;
        // 新增
        this.$refs.baseInfoFormRef.validate((valid) => {
          if (valid) {
            params = {
              ...this.repairInfoFormData,
              companyCode: this.userInfo.companyCode,
              companyName: this.userInfo.companyName,
              departmentCode: this.userInfo.departmentCode,
              departmentName: this.userInfo.departmentName,
              tenantCode: this.userInfo.tenantCode,
              submitFlag: this.submitFlag,
              oaId: this.userInfo.oaId,
              repairCompanyName: this.userInfo.companyName,
              attachments: this.$refs.fileTableRef.getTableData(),
              dispatchFlag: 0,
              id: this.repairId,
              createBy: this.userInfo.personName,
            };
          } else {
            this.$message.error('请检查数据再提交');
          }
        });
        await this.$refs.maintenanceTableRef.validate((valid) => {
          if (valid) {
            params = {
              ...params,
              repairProjects: this.$refs.maintenanceTableRef.getTableData().fullData,
            };
          } else {
            params = null;
            this.$message.error('请检查数据再提交');
          }
        });
        return params;
      },

      // 编辑页面获取入参
      async getEditPageData() {
        // console.log("this.getSubmitData()",this.getSubmitData())
        let params = await this.getSubmitData();
        let params2 = {};
        if (params) {
          if (params.repairPersonName === '') {
            params.repairPersonName = this.userInfo.personName;
          }
          if (params.repairDate === '') {
            params.repairDate = formatDate(new Date());
          }
          if (this.pageMode == 2) {
            params2 = {
              companyCode: this.userInfo.companyCode,
              companyName: this.userInfo.companyName,
              departmentCode: this.userInfo.departmentCode,
              departmentName: this.userInfo.departmentName,
              repairNo: params.repairNo,
              repairDepartmentNo: params.repairDepartmentNo,
              repairDepartmentName: params.repairDepartmentName,
              name: params.name,
              repairPersonName: params.repairPersonName,
              repairCompanyName: params.repairCompanyName,
              repairCompanyNo: params.repairCompanyNo,
              repairPriceType: params.repairPriceType,
              repairDate: params.repairDate,
              submitFlag: this.submitFlag,
              oaId: this.userInfo.oaId,
              id: this.repairId,
              repairProjects: this.$refs.maintenanceTableRef.getTableData().fullData.map((item) => {
                return {
                  content: item.content,
                  estimatedCost: item.estimatedCost,
                  id: item.id,
                  isDelete: item.isDelete,
                  location: item.location,
                  plan: item.plan,
                  repairId: item.repairId,
                  type: item.type,
                  _XID: item._XID,
                };
              }),
              attachments: this.$refs.fileTableRef.getTableData(),
            };
          } else {
            params2 = params;
          }
        }
        return params2;
      },

      // 保存按钮
      async saveBtn() {
        this.saveBtnClickHandler(this.submitFlag);
      },
      //提交审核按钮
      async submitBtn() {
        this.submitFlag = true;
        this.saveBtnClickHandler(this.submitFlag);
      },
      // 保存、提交审核接口方法
      async saveBtnClickHandler(flag) {
        this.submitFlag = flag;
        const params = await this.getEditPageData();
        console.log('params', params);
        if (params.repairDepartmentNo) {
          if (params.repairProjects.length) {
            this.loading.startLoading();
            let res = await this.$axios.post(API.REPAIRORDER_SAVE, params);
            this.loading.endLoading();
            console.log('res:', res);
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              });
              let pathList = {
                fromPath: {
                  path: this.$route.path,
                  name: this.$route.name,
                  meta: {
                    keepAlive: true,
                  },
                },
                toPath: {
                  path: '/property/repairsManagement',
                  name: 'repairsManagement',
                  meta: {
                    keepAlive: false,
                  },
                },
              };
              this.$store.dispatch('tagsView/delView', pathList.fromPath).then(() => {
                this.$nextTick(() => {
                  this.$router.push(pathList.toPath);
                });
              });
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg,
              });
            }
          } else {
            this.$message.error('维修项目必填');
          }
        }
      },

      // 取消按钮
      cancelBtnClickHandler() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              // title: '添加报修单',
            },
          },
          toPath: {
            path: '/property/repairsManagement',
            name: 'repairsManagement',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$confirm('确定取消吗?已输入的内容将不会保存', '提示')
          .then(() => {
            this.$store.dispatch('tagsView/delView', pathList.fromPath).then(() => {
              this.$nextTick(() => {
                this.$router.push(pathList.toPath);
              });
            });
          })
          .catch(() => {
            console.log('取消');
          });
      },
      // 通过按钮
      passBtn() {
        this.$refs.repairTypeDialogRef.openDialog();
        // this.passBtnClickHandler(this.reviewFlag);
      },
      // 驳回按钮
      rejectBtn() {
        this.reviewFlag = false;
        this.passBtnClickHandler(this.reviewFlag);
      },
      // 通过、驳回接口
      async passBtnClickHandler(flag) {
        let params = null;
        this.$refs.auditInfoFormRef.validate((valid) => {
          if (valid) {
            params = {
              repairProjects: this.$refs.maintenanceTableRef.getTableData().fullData.map((item) => {
                return {
                  content: item.content,
                  estimatedCost: item.estimatedCost,
                  id: item.id,
                  isDelete: item.isDelete,
                  location: item.location,
                  plan: item.plan,
                  repairId: item.repairId,
                  type: item.type,
                  _XID: item._XID,
                };
              }),
              ...this.auditFormData,
              reviewFlag: flag,
              id: parseInt(this.repairId),
            };
          } else {
            this.$message.error('请检查数据再提交');
            if (this.reviewFlag) this.$refs.repairTypeDialogRef.closeDialog();
            return params;
          }
        });
        params = {
          ...params,
          repairPriceType: this.repairPriceType,
          attachments: this.$refs.fileTableRef.getTableData(),
        };
        if (params) {
          this.loading.startLoading();
          let res = await this.$axios.post(API.REPAIRORDER_REVIEW, params);
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: '审核操作成功',
              type: 'success',
            });
            let pathList = {
              fromPath: {
                path: this.$route.path,
                name: this.$route.name,
                meta: {
                  keepAlive: true,
                },
              },
              toPath: {
                path: '/property/repairsManagement',
                name: 'repairsManagement',
                meta: {
                  keepAlive: false,
                },
              },
            };
            this.$store.dispatch('tagsView/delView', pathList.fromPath).then(() => {
              this.$nextTick(() => {
                this.$router.push(pathList.toPath);
              });
            });
          }
        }
      },

      // 选中触发事件维修项目表格
      handleSelectionChange(row) {
        this.multipleSelection = row.selection;
      },

      // 删除行（维修项目）
      deleteBtnClickHandler() {
        console.log('维修项目', this.$refs.maintenanceTableRef.getTableData().fullData);
        let selectRecords = this.$refs.maintenanceTableRef.getCheckboxRecords();
        console.log(selectRecords);
        if (this.multipleSelection.length) {
          this.$refs.maintenanceTableRef.removeSelecteds();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('请选择数据'),
            type: 'error',
          });
        }
      },

      // 维修项目表格校验
      async closeEditTableHandler() {
        const $table = this.$refs.maintenanceTableRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          // this.$message.error('请检查维修项目表格数据');
          return;
        } else {
          // await $table.clearActived();
        }
      },
      // 获取维修项目表格数据
      // getTableData() {
      //   const $table = this.$refs.maintenanceTableRef;
      //   this.repairProjects = $table.getTableData().fullData;
      //   console.log('获取维修表格数据', this.repairProjects);
      //   console.log('维修项目', this.$refs.maintenanceTableRef.getTableData().fullData);
      // },

      // 获取报修单详情
      async getFormData() {
        let id = this.repairId;
        let { data } = await this.$axios.post(`${API.REPAIRORDER_DETAIL}/${id}`);
        console.log('详情data', data);
        if (data.code == 0) {
          this.repairInfoFormData = this.translateFiled(data.data, 'repairOrderDTO');
          this.form.repairPriceType = this.repairInfoFormData.repairPriceType;
          this.repairInfoFormData.workOrderNo = data.data.workOrderList;
          this.maintenanceTableData = data.data.repairProjects;
          // let approvalTasks = Array.isArray(data.data.approvalTasks) ? data.data.approvalTasks : [];
          // if (data.data.approvalTasks) {
          //   this.auditRecordTableData = [...this.auditRecordTableData, ...data.data.approvalTasks];
          // }
          this.attachments = data.data.attachmentVO;
          if (this.pageMode == 4) {
            console.log(this.$route.query.status, 'status');
            this.repairInfoFormData.workOrderNo = data.data.workOrderList;
            // this.getApprovalList(this.repairInfoFormData.repairNo);
          }
        }
      },

      // 根据维修编号获取审核记录
      async getApprovalList(repairNo) {
        this.load = true;
        const { data } = await this.$axios.post('/component/approvalTask/queryPage', {
          billType: 'repair',
          operateType: 'submit',
          status: 'done',
          businessNo: repairNo,
        });
        if (data.code == 0) {
          this.auditRecordTableData = [
            ...this.auditRecordTableData,
            ...this.translateFiled(data.data.records, 'approvalTask'),
          ];
          this.auditRecordTableData = this.auditRecordTableData.map((item) => {
            return {
              ...item,
              gmtModifiedMap: Date.parse(item.gmtModified),
            };
          });
          this.auditRecordTableData.sort((a, b) => {
            return b.gmtModifiedMap - a.gmtModifiedMap; // 按照验收记录创建时间倒叙
          });
          this.load = false;
        } else {
          this.$message.error(data.msg);
        }
        console.log('审核记录', data, this.auditRecordTableData);
      },

      getName(type, value) {
        if (value == null) {
          return '';
        }
        let item;
        let res = '';
        if (type == 'type') {
          item = this.typeList.find((item) => item.value == value);
          res = item.label ? item.label : '';
          console.log('res', res);
          return res;
        }
      },
      changeMethod(row) {
        if (row.prop == 'repairDepartmentNo') {
          this.repairInfoFormData.repairDepartmentNo = row.val;
          this.repairInfoFormData.repairDepartmentName = this.translateApplyDepartmentName(row.val);
          console.log('repairInfoFormData', this.repairInfoFormData);
        }
      },
      // 获取部门name
      translateApplyDepartmentName(val) {
        console.log(val, 'vale');
        return this.departmentList.find((item) => item.value == val)?.label;
      },
    },
    components: {
      SiruiSearch,
      RepairTypeDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .vxe-table-element {
    ::v-deep .vxe-body--column {
      .vxe-cell {
        max-height: fit-content !important;
      }
    }
  }
  // }
</style>
